import { observer } from 'mobx-react'
import React from 'react'
import styles from './OCRScopeJobDetailFooter.sass'
import Button from 'components/Button'
import OCRScopingJobMainPanelViewModel from '../OCRScopingJobMainPanelViewModel'

interface OCRScopeJobDetailFooterProps {
  vm: OCRScopingJobMainPanelViewModel
}

export default observer(function OCRScopeJobDetailFooter({
  vm,
}: OCRScopeJobDetailFooterProps) {
  if (!vm.hasScopeWork || vm.isScopingInProgress) {
    return
  }
  if (!vm.canManageOCRScopingJobs && !vm.isReadyToSubmit) {
    return
  }

  const selectedScopeWork = vm.selectedScopeWork

  return (
    <div className={styles.detailFooterContainer}>
      <div className={styles.detailFooterLeftContainer}>
        {!selectedScopeWork.archived && (
          <Button
            onClick={vm.confirmArchiveModalVM.show}
            disabled={vm.isPending}
          >
            Delete
          </Button>
        )}
      </div>

      <div className={styles.detailFooterRightContainer}>
        {vm.isErrorOccured && (
          <>
            <Button onClick={vm.rerun} disabled={vm.isPending}>
              Rerun OCR
            </Button>
            <Button
              type={'primary'}
              onClick={vm.openLinkManuallyModal}
              disabled={vm.isPending}
            >
              Job Created Manually
            </Button>
          </>
        )}

        {vm.isUnderReview && (
          <Button
            type={'primary'}
            onClick={vm.confirmReviewModalVM.show}
            disabled={vm.isPending}
          >
            Set As Ready To Submit
          </Button>
        )}

        {vm.isReadyToSubmit && (
          <Button
            type={'primary'}
            disabled={!vm.canSubmitJob || vm.isPending}
            onClick={vm.confirmSubmitModalVM.show}
          >
            Submit
          </Button>
        )}
      </div>
    </div>
  )
})
